import React from "react";

// css
import "./HomePage.scss";

function HomePage() {
  return (
    <div className="mainBox_shadowMain HomePage">土地台帳建檔輔助系統</div>
  );
}

export default HomePage;
